/* istanbul ignore file */

import React from "react";
import { bedragFormatNull } from "../infra/scenario-utils";
import Table from "../../components/Table";
import { Column } from "../../components/BaseTable";

export interface ControleWerkelijkeLastenTableProps {
  toegestaneLastBedragen: (number | null)[];
  werkelijkeLastBedragen: (number | null)[];
  tekortToegestaneLastBedragen: (number | null)[];
}

export const ControleWerkelijkeLastenTable: React.FC<ControleWerkelijkeLastenTableProps> = ({
  toegestaneLastBedragen,
  werkelijkeLastBedragen,
  tekortToegestaneLastBedragen,
}: ControleWerkelijkeLastenTableProps) => {
  const data = toegestaneLastBedragen.map((_, index) => ({
    toegestaneLast: bedragFormatNull(toegestaneLastBedragen[index]),
    werkelijkeLast: bedragFormatNull(werkelijkeLastBedragen[index]),
    tekort: bedragFormatNull(tekortToegestaneLastBedragen[index]),
  }));

  // Filter opeenvolgende dubbele rijen o.b.v. weergegeven kolommen
  const filteredData = data.filter((row, index, arr) => {
    if (index === 0) return true;
    const prev = arr[index - 1];
    return (
      row.toegestaneLast !== prev.toegestaneLast ||
      row.werkelijkeLast !== prev.werkelijkeLast ||
      row.tekort !== prev.tekort
    );
  });

  const columns: Column[] = [
    {
      header: "Toegestane last o.b.v. inkomen",
      accessor: "toegestaneLast",
    },
    {
      header: "Werkelijke bruto last van hypotheek en verpande producten",
      accessor: "werkelijkeLast",
    },
    {
      header: "Tekort o.b.v. werkelijke bruto last",
      accessor: "tekort",
      violation: (value: string) => {
        const numericValue = parseFloat(value.replace(/[^0-9.-]+/g, ""));
        return numericValue > 0;
      },
    },
  ];

  return (
    <Table
      columns={columns}
      data={filteredData}
      rotate
      id="controle-werkelijke-lasten-table"
      className="scenario__table mb-4 table table-striped table-bordered table-hover table-responsive"
    />
  );
};
